<template lang="pug">
    .cookies
        .container
            app-closer(@click.native="$emit('close')")
            h3(v-html="$t('cookiesPopup.title')")
            .bottom
                p
                    span(v-html="$t('cookiesPopup.text')")
                    a(:href="'/static/files/cookies_'+$i18n.locale+'.pdf'" target="_blank" v-html="$t('cookiesPopup.link1')")
                    a(:href="'/static/files/cookies_'+$i18n.locale+'.pdf'" target="_blank" v-html="$t('cookiesPopup.link2')")
                .app_btn.light_blue(@click="allow()" v-html="$t('cookiesPopup.allow')")
</template>

<script>
    export default {
        name: "Cookies",
        methods:{
            allow(){
                this.$cookie.set('cookiesAllowed', 1, 1000);
                this.$emit('close');
            }
        }
    }
</script>

<style scoped lang="scss">
    .cookies{
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 100;
        width: 100vw;
        background: rgba(#022543,  0.96);
        .container{
            position: relative;
            max-width: 81.3rem;
            padding: 2.3rem 4rem 2.3rem 4.4rem;
        }
        .closer{
            position: absolute;
            top: 1rem;
            right: 1rem;
            width: 1.75rem;
            height: 1.75rem;
            &:before, &:after{
                background: #fff;
                height: 2px;
            }
        }
        h3{
            margin-bottom: 0.4rem;
            font-size: to_rem(30px);
            color: $light_blue;
        }
        .bottom{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
        }
        p{
            font-family: Arial;
            font-size: to_rem(18px);
            line-height: 1.25;
            a{
                position: relative;
                color: #fff;
                &:after{
                    content: '';
                    display: block;
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background: #fff;
                }
            }
        }
        @include mobile_or_P{
            text-align: center;
            .container{
                padding: 3.4rem 2.5rem 3.7rem 2.5rem;
            }
            h3{
                margin-bottom: 0.9rem;
                font-size: 1.42rem;
                line-height: 1.2;
            }
            .bottom{
                flex-direction: column;
                align-items: center;
            }
            p{

                max-width: 80%;
                margin-bottom: 1.8rem;
                font-size: 1.045rem;
                line-height: 1.2;
            }
            .app_btn{
                width: 85%;
                justify-content: center;
                font-size: 1.6rem;
            }
            @include landscape{
                .container{
                    padding: 2rem 2.5rem 2rem 2.5rem;
                }
                h3{
                    max-width: 90%;
                    margin: 0 auto 0.7rem;
                    font-size: 1.2rem;
                }
                p{
                    margin-bottom: 1.3rem;
                    font-size: 0.75rem;
                }
                .app_btn{
                    font-size: 1.2rem;
                }
            }
        }
    }
</style>
